var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGoto(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#40464D",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M6,1 L6,2 L3,2 C1.9456382,2 1.08183488,2.81587779 1.00548574,3.85073766 L1,4 L1,15 C1,16.0543618 1.81587779,16.9181651 2.85073766,16.9945143 L3,17 L14,17 C15.0543618,17 15.9181651,16.1841222 15.9945143,15.1492623 L16,15 L16,12 L17,12 L17,15 C17,16.6568542 15.6568542,18 14,18 L3,18 C1.34314575,18 0,16.6568542 0,15 L0,4 C0,2.34314575 1.34314575,1 3,1 L6,1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64644661,4.35355339 L19.1464466,4.35355339 L19.1464466,4.35355339 L19.1464466,5.35355339 L7.64644661,5.35355339 C7.37030423,5.35355339 7.14644661,5.12969577 7.14644661,4.85355339 C7.14644661,4.57741102 7.37030423,4.35355339 7.64644661,4.35355339 Z",
    transform: "rotate(-45 13.146 4.854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,7 C11.2238576,7 11,6.77614237 11,6.5 C11,6.22385763 11.2238576,6 11.5,6 L17,6 L17,0.5 C17,0.223857625 17.2238576,-7.1223362e-15 17.5,-7.10542736e-15 C17.7761424,-7.08851851e-15 18,0.223857625 18,0.5 L18,6 C18,6.51283584 17.6139598,6.93550716 17.1166211,6.99327227 L17,7 L11.5,7 Z",
    transform: "rotate(-90 14.5 3.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGoto);
export default __webpack_public_path__ + "static/media/ic-goto.606ada036ecafa3ed7cdc0919ac5caa8.svg";
export { ForwardRef as ReactComponent };